export enum PromoCodeType {
    RECURRING = 'recurring',
    LIMITED = 'limited',
}

export enum PromoCodeDiscountType {
    PERCENTAGE = 'percentage',
    AMOUNT = 'amount',
}

export interface PromoCode {
    _id?: string;
    code: string;
    discount_value: number;
    discount_type: PromoCodeDiscountType;
    type: PromoCodeType;
    usages_remaining: number;
    is_active: boolean;
    description?: string;
    expires_at?: Date;
    has_prerequisite?: boolean;
    prerequisite_min_adults?: number;
    prerequisite_exact_adults?: boolean;
    prerequisite_min_children?: number;
    prerequisite_exact_children?: boolean;
    promocode_created_at?: Date;
    promocode_updated_at?: Date;
}

export interface PromoCodeValidationResult {
    valid: boolean;
    code: string;
    discount_value: number;
    discount_type: PromoCodeDiscountType | null;
    type: PromoCodeType | null;
    message: string;
}
